const defaultState = {
  isLoaded: true,
  isLoadedSubjects: false,
  subjects: [],
  categories: [],
  sources: [],
  subcategories: [],
  selectSubject: null,
  selectSource: null,
  selectCategory: null,
  selectSubcategory: null,
  list: [],
  labels: [],
  checkCategories: [],
  checkSubcategories: [],
  isShowModal: false,
  isTrashed: false,
  item: {},
  statistic: [],
  statistic_total: [],
  total: 0,
  query: {
    limit: 10,
    offset: 0,
  }
}

const question = (state = defaultState, action) => {
  switch (action.type) {
    case 'CREATE_QUESTION':
      return {
        ...state,
        list: (state.checkCategories.includes(action.data.category_id) || (action.data.subcategory_id && state.checkSubcategories.includes(action.data.subcategory_id))) ? [...state.list, action.data] : state.list,
        isLoaded: true
      }
    case 'UPDATE_QUESTION':
      return {
        ...state,
        list: state.list.map(_i => _i.id == action.data.id ? {...action.data} : {..._i}),
        // list: (state.isTrashed || state.checkCategories.includes(action.data.category_id) || (action.data.subcategory_id && state.checkSubcategories.includes(action.data.subcategory_id))) ? state.list.map(_i => _i.id == action.data.id ? {...action.data} : {..._i}) : state.list.filter(_i => _i.id != action.data.id),
        isLoaded: true
      }
    case 'DELETE_QUESTION':
      return {
        ...state,
        list: state.list.filter(_i => _i.id != action.data),
        isLoaded: true
      }
    case 'SET_QUESTIONS':
      return {
        ...state,
        list: action.data,
        total: action.count,
        query: action.query,
        statistic: action.statistic,
        statistic_total: action.statistic_total,
        isLoaded: true
      };
    case 'SET_QUESTION_LABELS':
      return {
        ...state,
        labels: action.data,
      };
    case 'SET_QUESTION_LABEL_UPDATE':
      return {
        ...state,
        labels: state.labels.map(_i => _i.id == action.data.id ? {...action.data} : {..._i}),
      };
    case 'SET_QUESTION_LABEL_DELETE':
      return {
        ...state,
        labels: state.labels.filter(_i => _i.id != action.data ),
      };
    case 'SET_QUESTION_LABEL_CREATE':
      return {
        ...state,
        labels: [...state.labels, action.data],
      };
    case 'SET_QUESTIONS_SUBJECTS':
      return {
        ...state,
        subjects: action.data,
        isLoadedSubjects: true,
        isLoaded: true
      };
    case 'SET_QUESTIONS_SOURCES':
      return {
        ...state,
        sources: action.data,
        isLoadedSubjects: true,
        isLoaded: true
      };
    case 'SET_QUESTIONS_SUBJECTS_ADD':
      return {
        ...state,
        subjects: [...state.subjects, action.data],
        isLoaded: true
      };
    case 'SET_QUESTIONS_SOURCES_ADD':
      return {
        ...state,
        sources: [...state.sources, action.data],
        isLoaded: true
      };
    case 'SET_QUESTIONS_SOURCES_UP':
      return {
        ...state,
        sources: state.sources.map(_i => action.data.id == _i.id ? {...action.data} : {..._i}, ),
        isLoaded: true
      };
    case 'SET_QUESTIONS_SUBJECTS_UP':
      return {
        ...state,
        subjects: state.subjects.map(_i => action.data.id == _i.id ? {...action.data} : {..._i}, ),
        isLoaded: true
      };
    case 'SET_QUESTIONS_CATEGORY_UPDATE':
      return {
        ...state,
        categories: !action.data.category_id ? state.categories.map(_i => _i.id == action.data.id ? {...action.data} : {..._i}, ) : state.categories,
        subcategories: action.data.category_id ? state.subcategories.map(_i => _i.id == action.data.id ? {...action.data} : {..._i}, ) : state.subcategories,
        isLoaded: true
      };
    case 'SET_QUESTIONS_CATEGORY_ADD':
      return {
        ...state,
        categories: !action.data.category_id ? [...state.categories, action.data] : state.categories,
        subcategories: action.data.category_id ? [...state.subcategories, action.data] : state.subcategories,
        isLoaded: true
      };
    case 'SET_QUESTIONS_SUBJECTS_DELETE':
      return {
        ...state,
        subjects: state.subjects.filter(_i => _i.id != action.data),
        selectSubject: null,
        isLoaded: true
      };
    case 'SET_QUESTIONS_SOURCES_DELETE':
      return {
        ...state,
        sources: state.sources.filter(_i => _i.id != action.data),
        selectSource: null,
        isLoaded: true
      };
    case 'SET_QUESTIONS_CATEGORY_DELETE':
      return {
        ...state,
        categories: state.categories.filter(_i => _i.id != action.data),
        selectCategory: null,
        list: state.list.filter(_i => _i.category_id != action.data),
        checkCategories: state.checkCategories.filter(_i => _i != action.data),
        isLoaded: true
      };
    case 'SET_QUESTIONS_SUBCATEGORY_DELETE':
      return {
        ...state,
        subcategories: state.subcategories.filter(_i => _i.id != action.data),
        list: state.list.filter(_i => _i.subcategory_id != action.data),
        checkSubcategories: state.checkSubcategories.filter(_i => _i != action.data),
        selectSubcategory: null,
        isLoaded: true
      };
    case 'SET_QUESTIONS_CATEGORIES':
      return {
        ...state,
        categories: action.data,
        subcategories: action.subcategories,
        isLoadedCategories: true,
        isLoaded: true
      };
    case 'SET_QUESTIONS_KEY':
      return {
        ...state,
        [action.key]: action.data,
      };
    default:
      return state
  }
}

export default question;
